import React, { useMemo } from 'react'
import { uniqueId } from 'lodash-es'

interface IProps {
  value?: boolean | string[]
  name?: string
  onChange?: (value: boolean | string[] | string) => void
  hasError?: boolean
  disabled?: boolean
  className?: string
  children?: React.ReactNode | string
}

function CheckboxControl(props: IProps): React.ReactElement {
  const name = React.useRef(props.name ?? 'checkbox')
  const id = React.useRef(uniqueId(name.current))

  const checked = useMemo(() => {
    if (typeof props.value === 'boolean') return props.value
    if (Array.isArray(props.value)) return props.value.includes(name.current)

    return undefined
  }, [props.value])

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>): void => {
    if (!props.onChange) return

    const { value, checked } = e.target

    if (typeof props.value !== 'undefined') {
      if (typeof props.value === 'boolean') props.onChange(checked)
      if (Array.isArray(props.value)) {
        if (checked) props.onChange([...props.value, name.current])
        else props.onChange(props.value.filter((item) => item !== name.current))
      }

      return
    }

    props.onChange(value)
  }

  return (
    <div
      className={`checkbox-control ${props.className ?? ''} ${
        props.hasError ? '_has-error' : ''
      } ${props.disabled ? '_disabled' : ''}`.trim()}
    >
      <label htmlFor={id.current}>
        <input
          checked={checked}
          type="checkbox"
          id={id.current}
          name={name.current}
          value={name.current}
          onChange={handleChange}
        ></input>

        <span className="checkbox-control__check"></span>
        {props.children && (
          <span className={'checkbox-control__label'}>{props.children}</span>
        )}
      </label>
    </div>
  )
}

export default CheckboxControl
